/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

const ConnectedInvoiceLink = ({ associatedInvoices, isEstimate, toggleConnectedInvoicesModal }) => {
    const { lang } = global;

    if (!(isEstimate && associatedInvoices && associatedInvoices.length > 0)) return null;

    return (
        <div className="row form-section">
			<div className="col-xs-6 col-md-5 col-lg-4">
				<label>
					{lang.t(associatedInvoices.length > 1 ? "Connected Invoices" : "Connected Invoice")}
				</label>
				<If condition={associatedInvoices.length === 1}>
					<Link
						to={`/payments/manualinvoice?id=${associatedInvoices[0].InvoiceId}`}
					>
						&nbsp;#{associatedInvoices[0].InvoiceNumber}
					</Link>
				</If>
				<If condition={associatedInvoices.length > 1}>
					:{" "}
					<button
						type="button"
						className="btn btn-link padding-left-0"
						onClick={() => toggleConnectedInvoicesModal(associatedInvoices)}
					>
						{lang.t("View All")}
					</button>
				</If>
			</div>
		</div>
    );
};

ConnectedInvoiceLink.propTypes = {
	associatedInvoices: PropTypes.array.isRequired,
	isEstimate: PropTypes.bool.isRequired,
	toggleConnectedInvoicesModal: PropTypes.func.isRequired
};

export default ConnectedInvoiceLink;
